<template>
    <div
        class="width100 topmenu greybg paddingtop5 paddingbottom5"
        style="border-bottom: 1px; border-bottom-style: solid; border-bottom-color: #e6e6e6"
    >
        <div class="center">
            <div
                v-if="belMeConfig"
                class="floatleft font11"
                id="text-openingstijden"
            >
                <font-awesome-icon
                    class="fa-flip-horizontal"
                    icon="phone"
                    style="font-size: 13px;"
                    size="2x"
                />
                Advies nodig?
                <span v-if="currentlyOpen">
                    Wij zijn vandaag tot {{ belMeConfig[currentDayOfWeek][1] }}
                </span>
                <span v-else="">
                    Wij zijn morgen weer vanaf
                    {{ belMeConfig[nextDayOfWeek][0] }}
                </span>
                <span class="openingstijden"
                    >bereikbaar
                    <ul class="lijst arrow_box">
                        <li
                            v-for="(day, dayIndex) in belMeConfig"
                            :key="'OpeningstijdenList' + dayIndex"
                            v-if="dayIndex !== 'enabled'"
                            class="lijst-item mon"
                        >
                            {{ shortDayToRegional(dayIndex) }}
                            {{ day[0] }}
                            -
                            {{ day[1] }}
                        </li>
                    </ul></span
                >
            </div>
            <div class="floatright">
                <div class="floatright">
                    <form
                        id="form1008"
                        enctype="application/x-www-form-urlencoded"
                        class="floatright"
                        method="post"
                        action="/nieuwsbrief"
                    >
                        <span v-if="subscriberCount > 0" class="font11">
                            <font-awesome-icon icon="envelope" />
                            De beste Cruise Deals?
                            <i>{{
                                Number(subscriberCount).toLocaleString()
                            }}</i>
                            mensen zijn je voorgegaan!
                        </span>
                        <input
                            onfocus=""
                            id="field1076"
                            name="email"
                            class="required email popup-email height20 lineheight20 font11 marginright10"
                            placeholder="jouwnaam@gmail.com"
                            type="email"
                        />

                        <input
                            value="Inschrijven"
                            class="submitButton small-button button-orange white round5 noborder popup-button bold nomargin height20 lineheight20 font11 floatright"
                            name="next"
                            id="field1082"
                            type="submit"
                        />

                        <fieldset style="display: none">
                            <input
                                name="campagne"
                                value="verrijking"
                                type="hidden"
                            />
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'headerTop',
    methods: {
        shortDayToRegional: function(shortName) {
            let result = this.regionalDays.find(function(item) {
                return item.shortName === shortName
            })

            if (
                typeof result !== 'undefined' &&
                result !== null &&
                result.regionalName
            ) {
                return result.regionalName
            }

            return ''
        },
        findDayIndex: function(offset = 0) {
            let date = new Date()
            let day = date.getDay() + offset
            if (day >= 7) day = 0

            let result = this.regionalDays.find(function(item) {
                return item.index === day
            })

            return result
        },
    },
    computed: {
        subscriberCount: function() {
            return this.$store.state.subscriberCount
        },
        belMeConfig: function() {
            return this.$store.state.belMeConfig
        },
        regionalDays: function() {
            return this.$store.state.regionalDays
        },
        currentlyOpen: function() {
            return this.$store.getters.currentlyOpen
        },
        currentDayOfWeek: function() {
            let result = this.findDayIndex(0)
            if (
                typeof result !== 'undefined' &&
                result !== null &&
                result.regionalName
            ) {
                return result.shortName
            }
            return ''
        },
        nextDayOfWeek: function() {
            let result = this.findDayIndex(1)
            if (
                typeof result !== 'undefined' &&
                result !== null &&
                result.shortName
            ) {
                return result.shortName
            }
            return ''
        },
    },
}
</script>

<style scoped>
.openingstijden {
    color: #3cb221;
    text-decoration: underline;
    font-weight: 600;
    cursor: pointer;
    margin-left: 3px;
}

.openingstijden-dicht {
    color: #000000;
    text-decoration: underline;
    font-weight: 600;
    cursor: pointer;
    margin-left: 3px;
}

.lijst {
    margin-left: 200px !important;
    margin-top: 5px !important;
    padding: 3px 3px 3px 7px !important;
    background: #f8f8f8;
    z-index: 5;
    color: initial;
    font-weight: initial;
    border: 1px solid #e6e6e6;
    box-shadow: 0 0 2px 0 rgba(19, 41, 61, 0.2);
}

.lijst-item {
    padding-left: 5px;
    margin-top: 3px !important;
}

.arrow_box {
    position: relative;
    background: #f8f8f8;
    border: 1px solid #e6e6e6;
}

.arrow_box:after,
.arrow_box:before {
    bottom: 100%;
    left: 25%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}

.arrow_box:after {
    border-color: rgba(248, 248, 248, 0);
    border-bottom-color: #f8f8f8;
    border-width: 10px;
    margin-left: -10px;
}

.arrow_box:before {
    border-color: rgba(230, 230, 230, 0);
    border-bottom-color: #e6e6e6;
    border-width: 11px;
    margin-left: -11px;
}

.vandaag {
    font-weight: 600;
}

.openingstijden:hover ul {
    display: block;
}

.openingstijden ul {
    position: absolute;
    width: 150px;
    display: none;
}

.openingstijden-dicht:hover ul {
    display: block;
}

.openingstijden-dicht ul {
    position: absolute;
    width: 150px;
    display: none;
}

.lijst ul li {
    display: block;
}

#cruise-logo {
    margin-top: 20px;
}

/* TOPMENU */

.topmenu {
    float: right;
    /*width: auto; */
}

#content h1 {
    font-size: 26px;
    margin-bottom: 8px;
}

.bel {
    float: left;
    text-align: right;
}

.checkjes-box {
    display: flex;
    flex-direction: row;
    margin-top: 17px;
}

.checkjes {
    font-size: 12px !important;
    color: #7bbe69;
    padding-right: 5px;
    margin-top: 4px;
}

.checkjes-text {
    color: black;
    padding-right: 10px;
}

.topmenu ul,
.topmenu ul li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.topmenu ul li {
    float: left;
    margin-left: 5px;
    margin-top: 8px;
}

.spreek,
.tel {
    clear: both;
    display: block;
}

.tel {
    font-size: 25px;
    color: #f39c12;
    font-weight: bold;
}

.tijden {
    color: #666666;
    font-size: 12px;
}

.topmenu ul li.item288 {
    border-right: 1px solid #f0f0f0;
    padding-right: 20px;
    margin-top: 0;
}

.topmenu ul,
.topmenu ul li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.topmenu ul li {
    float: left;
    margin-left: 5px;
    margin-top: 8px;
}

.spreek,
.tel {
    clear: both;
    display: block;
}

.tel {
    font-size: 25px;
    color: #f39c12;
    font-weight: bold;
}

.tijden {
    color: #666666;
    font-size: 12px;
}

.topmenu ul li.item288 {
    border-right: 1px solid #f0f0f0;
    padding-right: 20px;
    margin-top: 0;
}
</style>
